import Layout from "@components/Layout"
import RadioInputButton from "@components/RadioInputButton"
import { useTranslation } from "react-i18next"
import { Form, useSubmit } from "react-router-dom"

export default function DistractionsPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    submit(event.currentTarget.form)
  }

  return (
    <Layout>
      <div className="shrink-0">
        <h1 className="custom-heading">
          {t("pages.onboarding.distractions.heading")}
        </h1>
      </div>

      <Form className="flex grow flex-col justify-center gap-5" method="post">
        <RadioInputButton
          className="from-pd-blue"
          emoji="🥷"
          label={t("pages.onboarding.distractions.focus_master")}
          name={t("pages.onboarding.distractions.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboarding.distractions.focus_master", {
            lng: "en",
          })}
        />

        <RadioInputButton
          className="from-pd-peach"
          emoji="😎"
          label={t("pages.onboarding.distractions.typically_on_track")}
          name={t("pages.onboarding.distractions.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboarding.distractions.typically_on_track", {
            lng: "en",
          })}
        />

        <RadioInputButton
          className="from-pd-yellow"
          emoji="🤔"
          label={t("pages.onboarding.distractions.sometimes_sidetracked")}
          name={t("pages.onboarding.distractions.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboarding.distractions.sometimes_sidetracked", {
            lng: "en",
          })}
        />

        <RadioInputButton
          className="from-pd-green"
          emoji="🎈"
          label={t("pages.onboarding.distractions.easily_sidetracked")}
          name={t("pages.onboarding.distractions.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboarding.distractions.easily_sidetracked", {
            lng: "en",
          })}
        />
      </Form>
    </Layout>
  )
}
